import AdminLogin from "../screens/nonAuth/AdminLogin";
// import Register from "../screens/nonAuth/Register";
import Dashboard from "../screens/auth/Dashboard";
// import Home from "../screens/users/Home";
import About from "../screens/users/About";
import Contact from "../screens/users/Contact";
import AdminProfile from "../screens/auth/AdminProfile";
import Campaign from "../screens/users/Campaign";
import Blog from "../screens/users/Blog";
import AdminCampaigns from "../screens/auth/AdminCampaigns";
import AdminServices from "../screens/auth/AdminServices";
import AdminBlogs from "../screens/auth/AdminBlogs";
import Services from "../components/Service/Services";
import Gallery from "../screens/users/Gallery";
import BlogDetails from "../screens/users/BlogDetails";
import NewHome from "../screens/users/NewHome";
import OurWork from "../screens/users/OurWork";
import GetInvloved from "../screens/users/GetInvloved";
import OurTeam from "../screens/users/OurTeam";
import Profile from "../screens/users/Profile";
import AdminCampaignDetails from "../screens/auth/AdminCampaignDetails";
import AdminServiceDetails from "../screens/auth/AdminServiceDetails";
import EditAdminService from "../screens/auth/EditAdminService";
import CreateAdminService from "../screens/auth/CreateAdminService";
import AdminBlogDetails from "../screens/auth/AdminBlogDetails";
import AdminVolunteers from "../screens/auth/AdminVolunteers";
import AdminVolunteerApplicationsV2 from "../screens/auth/AdminVolunteerApplicationsV2";
import AdminVolunteerAppDetails from "../screens/auth/AdminVolunteerAppDetails";
import AdminGallery from "../screens/auth/AdminGallery";
import AdminUploadGallery from "../screens/auth/AdminUploadGallery";
import AdminCertificates from "../screens/auth/AdminCertificates";
import AdminTestimonials from "../screens/auth/AdminTestimonials";
import AdminCreateTestimonials from "../screens/auth/AdminCreateTestimonials";
import AFSAAllCampaigns from "../components/user/NewHome/AFSAAllCampaigns";
import SupportPartners from "../screens/users/SupportPartners";
import AdminTeams from "../screens/auth/AdminTeams";
import AdminImpactStats from "../screens/auth/AdminImpactStats";
import AdminContacts from "../screens/auth/AdminContacts";
import AdminPartners from "../screens/auth/AdminPartners";
import AdminSDGs from "../screens/auth/AdminSDGs";
import AdminBanners from "../screens/auth/AdminBanners";
import AdminCreateSDGs from "../screens/auth/AdminCreateSDGs";
import AdminEditBanner from "../screens/auth/AdminEditBanner";
import PaymentStatus from "../screens/users/PaymentStatus";
import SpecialCampaign from "../screens/auth/SpecialCampaign";
import SpecialCampaignDetails from "../screens/auth/SpecialCampaignDetails";
import PrivacyPolicy from "../screens/users/PrivacyPolicy";
import TermsConditions from "../screens/users/TermsConditions";
import ChildSafetyPolicy from "../screens/users/ChildSafetyPolicy";

export const authRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/featured-campaign",
    component: <AdminCampaigns />,
  },
  {
    path: "/special-campaign",
    component: <SpecialCampaign />,
  },
  {
    path: "/admin-campaign-details",
    component: <AdminCampaignDetails />,
  },
  {
    path: "/special-campaign-details",
    component: <SpecialCampaignDetails />,
  },
  {
    path: "/admin-programmes",
    component: <AdminServices />,
  },
  {
    path: "/create-admin-service",
    component: <CreateAdminService />,
  },
  {
    path: "/edit-admin-service/:id",
    component: <EditAdminService />,
  },
  {
    path: "/admin-service-details/:id",
    component: <AdminServiceDetails />,
  },
  {
    path: "/admin-blogs",
    component: <AdminBlogs />,
  },
  {
    path: "/admin-blog-details/:id",
    component: <AdminBlogDetails />,
  },
  {
    path: "/admin-volunteers",
    component: <AdminVolunteers />,
  },
  {
    path: "/admin-volunteers-v2",
    component: <AdminVolunteerApplicationsV2 />,
  },
  {
    path: "/admin-volunteer-details/:id",
    component: <AdminVolunteerAppDetails />,
  },
  {
    path: "/admin-gallery",
    component: <AdminGallery />,
  },
  {
    path: "/admin-gallery-upload",
    component: <AdminUploadGallery />,
  },
  {
    path: "/admin-profile",
    component: <AdminProfile />,
  },
  {
    path: "/admin-certificates",
    component: <AdminCertificates />,
  },
  {
    path: "/admin-testimonials",
    component: <AdminTestimonials />,
  },
  {
    path: "/admin-create-testimonials",
    component: <AdminCreateTestimonials />,
  },
  {
    path: "/admin-teams",
    component: <AdminTeams />,
  },
  {
    path: "/admin-banners",
    component: <AdminBanners />,
  },
  {
    path: "/admin-create-banners",
    component: <AdminEditBanner />,
  },
  {
    path: "/admin-edit-banners/:id",
    component: <AdminEditBanner />,
  },
  {
    path: "/admin-interventions",
    component: <AdminImpactStats />,
  },
  {
    path: "/admin-contacts",
    component: <AdminContacts />,
  },
  {
    path: "/admin-partners",
    component: <AdminPartners />,
  },
  {
    path: "/admin-sdgs",
    component: <AdminSDGs />,
  },
  {
    path: "/admin-sdgs-edit",
    component: <AdminCreateSDGs />,
  },
  {
    path: "/admin-sdgs-edit/:id",
    component: <AdminCreateSDGs />,
  },
];

export const nonAuthRoutes = [
  {
    path: "/admin-login",
    component: <AdminLogin />,
  },
  // {
  //   path: "/admin-register",
  //   component: <Register />,
  // },
];

export const userRoutes = [
  {
    path: "/",
    component: <NewHome />,
  },
  {
    path: "/profile",
    component: <Profile />,
  },
  {
    path: "/campaigns",
    component: <AFSAAllCampaigns />,
  },
  {
    path: "/campaigns/:id",
    component: <Campaign />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/services",
    component: <OurWork />,
  },
  {
    path: "/services/:id",
    component: <Services />,
  },
  {
    path: "/get-involved",
    component: <GetInvloved />,
  },
  {
    path: "/our-team",
    component: <OurTeam />,
  },
  {
    path: "/our-support-partner",
    component: <SupportPartners />,
  },
  {
    path: "/payment-status",
    component: <PaymentStatus />,
  },

  {
    path: "/gallery",
    component: <Gallery />,
  },
  {
    path: "/blogs",
    component: <Blog />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },

  {
    path: "/blog-details/:id",
    component: <BlogDetails />,
  },
  {
    path: "/privacy-policy",
    component: <PrivacyPolicy />,
  },
  {
    path: "/privacy",
    component: <PrivacyPolicy />,
  },
  {
    path: "/terms-conditions",
    component: <TermsConditions />,
  },
  {
    path: "/terms-and-conditions",
    component: <TermsConditions />,
  },
  {
    path: "/terms",
    component: <TermsConditions />,
  },
  {
    path: "/child-safety-policy",
    component: <ChildSafetyPolicy />,
  },
  {
    path: "/child-safety",
    component: <ChildSafetyPolicy />,
  },
];
